import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//import './assets/index'
//导入icon
import '@/icons' // icon
import VueI18n from 'vue-i18n'
 
import i18n from './lang'


Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.config.productionTip = false
//import svgIcon from './compoent/svgicon'
//Vue.component('IconSvg', svgIcon)
new Vue({
  el: '#app',
  router,
  i18n,  
  render: h => h(App),
})
